export default "__VITE_ASSET__DOhj$xI2__"